import React, { forwardRef } from 'react';

// Helpers
import valueValidator from '../../helpers/valueValidator';

// Styles
import {
	ContentWrapperStyled,
	HeaderContainerStyled,
	HeaderWrapperStyled,
	InformationContainerStyled,
	InformationWrapperStyled,
	MetricWrapperStyled,
	IconWrapper,
} from './ListEntry.styled';

import {
	TitleStyled,
	LabelStyled,
	ValueStyled,
} from '../../library/Text.styled';

import { RightArrowIconStyled } from '../../library/Icons.styled';

const ListEntry = forwardRef((props, ref) => {
	const { entry, currentSelected, setHighlight } = props;

	const hasGeographicLocation =
		entry.hasOwnProperty('lat') && entry.hasOwnProperty('long');

	// Some formatting
	const location = hasGeographicLocation ? entry.venue4 : 'Distance Learning';
	const date = `${entry.startdate} - ${entry.enddate}`;
	const price = entry.price === -1 ? 'Free' : '£' + entry.price;

	return (
		<ContentWrapperStyled
			ref={ref}
			tabIndex={0}
			className={
				currentSelected.type === 'single' &&
				entry.id === currentSelected.entry.id
					? 'currentSelected'
					: ''
			}
			onClick={() =>
				setHighlight({
					entry: entry,
				})
			}
			onFocus={() =>
				setHighlight({
					entry: entry,
				})
			}
		>
			<HeaderContainerStyled>
				<HeaderWrapperStyled>
					<TitleStyled>{entry.classtitle}</TitleStyled>
					<IconWrapper>
						<RightArrowIconStyled />
					</IconWrapper>
				</HeaderWrapperStyled>
				{!hasGeographicLocation && (
					<InformationContainerStyled>
						<ValueStyled className={'distance-learning-course'}>
							{valueValidator(location)}
						</ValueStyled>
					</InformationContainerStyled>
				)}
			</HeaderContainerStyled>
			<InformationContainerStyled>
				<InformationWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled>Level:</LabelStyled>
						<ValueStyled>{valueValidator(entry.level)}</ValueStyled>
					</MetricWrapperStyled>
					{hasGeographicLocation && (
						<MetricWrapperStyled>
							<LabelStyled>Location:</LabelStyled>
							<ValueStyled>{valueValidator(location)}</ValueStyled>
						</MetricWrapperStyled>
					)}
					<MetricWrapperStyled>
						<LabelStyled>Cost:</LabelStyled>
						<ValueStyled>{valueValidator(price)}</ValueStyled>
					</MetricWrapperStyled>
				</InformationWrapperStyled>
				<InformationWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled>Date:</LabelStyled>
						<ValueStyled>{valueValidator(date)}</ValueStyled>
					</MetricWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled>Time:</LabelStyled>
						<ValueStyled>{valueValidator(entry.time)}</ValueStyled>
					</MetricWrapperStyled>
				</InformationWrapperStyled>
			</InformationContainerStyled>
		</ContentWrapperStyled>
	);
});

export default ListEntry;
